import React from 'react';
// import Marquee from "./marquee";
import { AiOutlineLink } from 'react-icons/ai';

const About = () => {
  return (
    <div className="about">
      <div className="about_container">
        <h1 className="about_title">
          <span>About</span> <span className="text_purple_lg"> Me</span>
        </h1>
        <div className="about_wrapper">
          <div className="about_left">
            <p>
              Hey there! My Name is{' '}
              <span className="text_purple_sm">Aryan Bhandari</span>. I enjoy
              designing and implementing solutions to real-world challenges. My
              interest in web development started back in 2018 when i wanted to
              create website portal for E-Books and hand written notes for all
              the students out there.
            </p>
            <p>
              Fast forward to now, I've had the pleasure of working in a early
              stage startup with a group of like-minded individuals. I am
              currently helping{' '}
              <span className="text_purple_sm">
                Zing - TakeAway delivery app
              </span>{' '}
              in their web development needs.
            </p>
            <a
              className="doconation-link"
              href="https://zingnow.in/"
              target="_blank"
              rel="noreferrer"
            >
              LINK <AiOutlineLink />
            </a>
          </div>
          <div className="about_right">
            <img src="images/coding.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
